export const STATEWIDE_MEASURES_CATEGORY = 'measure:statewide';
export const LOCAL_MEASURES_CATEGORY = 'measure:local';

export const mergeBallotCategoryOrder = (
  savedCategoryOrder: string[] | undefined,
  currentCategoryKeys: string[]
): string[] => currentCategoryKeys
  .map((categoryKey, currentIndex) => ({
    categoryKey,
    currentIndex,
    savedIndex: (savedCategoryOrder || []).indexOf(categoryKey),
  }))
  .sort((a, b) => {
    if (a.savedIndex === -1 && b.savedIndex === -1) return a.currentIndex - b.currentIndex;
    if (a.savedIndex === -1) return 1;
    if (b.savedIndex === -1) return -1;
    return a.savedIndex - b.savedIndex;
  })
  .map(({ categoryKey }) => categoryKey);

export const mergeRaceOfficeOrder = mergeBallotCategoryOrder;

export const mergeStatewideMeasureOrder = (
  savedMeasureOrder: string[] | undefined,
  alphabeticalMeasureKeys: string[]
): string[] => mergeBallotCategoryOrder(savedMeasureOrder, alphabeticalMeasureKeys);
